// removed by extract-text-webpack-plugin
module.exports = {"rankTable":"x4MBuyGYlLYk-7Ku6hhNg","table-success":"_3SvkOSCH-q5bISc8lo3nll","tableSuccess":"_3SvkOSCH-q5bISc8lo3nll","star":"rkPwLbjJzMyh39PTBbuQk"};